import React from "react";
import styled from "styled-components";
import { LIGHT_BLUE } from "../../../../../resources/Colors";

const Container = styled.div`
  background-color: ${({ background }) =>
    background ? `${background}` : `${LIGHT_BLUE}`};
  padding: 12px;
  padding-top: 8px;
  position: relative;
  border-radius: 8px;
  margin-bottom: 15px;

  p {
    margin: 5px 0px;
  }
`;

const Message = ({ message }) => {
  
  const isActive = () => {
    const activeKey = 'mesaggeActive';
    if(!message || !message.title || (Object.keys(message).includes(activeKey) && !message[activeKey]))
      return false;

    return true;
  }

  return isActive() && (
    <Container background={message.color}>
      <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: message.title }} />
    </Container>
  );
}
export default Message;